import Card from "@/atoms/CardKeyWorkers";
import NoDeposit from "@/public/icons/noDeposit.svg?url";
import EnableToBuy from "@/public/icons/enableToBuy.svg?url";
import NoMoreVacancies from "@/public/landlords/NoMoreVacancies.svg?url";
import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";
import routes from "@/constants/routes";
import Link from "next/link";

const PathToHomeOwnership = (): JSX.Element => {
  return (
    <section className="px-4 md:pt-12 bg-white md:px-16 lg:px-0">
      <h2 className="text-4xl font-bold lg:text-5xl text-landing-blue mb-12 xt-left text-center">
        Become a home owner faster
      </h2>
      <h3 className="font-serif text-xl md:text-2xl lg:text-3xl xl:w-1/2 mb-10 mx-auto text-center">
        Apply today to grab a Keyzy homes on a first come first service basis
      </h3>
      <div className="block lg:h-[388px] lg:flex lg:flex-row lg:justify-center lg:mb-11">
        <div className="flex flex-col items-center gap-6 lg:gap-10">
          <Card
            title="1. Find your ideal home"
            subtitle=""
            size="big"
            onlyHeading={true}
            image={EnableToBuy}
            layout="column"
          />
          <div className="flex justify-center">
            <Link href={routes.searchHomes}>
              <a className="block sm:min-w-[10rem] md:w-max px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow cursor-pointer xl:mt-0 bg-landing-orange hover:scale-105">
                Browse
              </a>
            </Link>
          </div>
        </div>

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block " />
        <div className="flex flex-col items-center gap-6 lg:gap-10">
          <Card
            title="2. Apply with Keyzy"
            subtitle=""
            size="big"
            onlyHeading={true}
            image={NoMoreVacancies}
            layout="column"
          />
          <div className="flex justify-center md:mt-0 lg:mt-9 xl:mt-10">
            <Link href={routes.register}>
              <a className="block min-w-[10rem] px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow cursor-pointer xl:mt-0 md:w-max bg-landing-cherry hover:scale-105">
                Sign up now
              </a>
            </Link>
          </div>
        </div>

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />
        <div className="flex flex-col items-center gap-6 lg:gap-10">
          <Card
            title="3. Move in and start saving"
            subtitle=""
            size="big"
            onlyHeading={true}
            image={NoDeposit}
            layout="column"
          />
          <div className="flex justify-center">
            <Link href={routes.howItWorks}>
              <a className="block min-w-[10rem] px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow cursor-pointer xl:mt-0 md:w-max bg-landing-denim hover:scale-105">
                See how it works
              </a>
            </Link>
          </div>
        </div>

        <HorizontalBar className="inline-block my-4 lg:hidden" />
      </div>

      <div className="relative h-full bg-white w-full overflow-hidden mb-9 md:mb-0">
        <div className="flex w-full left-0 right-0 m overflow-hidden bg-repeat-x lg:mt-7 h-24 md:h-36 xl:h-48 bg-[url('/intermediaries/city-outline-mobile.svg')]  md:bg-[url('/intermediaries/city-outline-tablet.svg')] xl:bg-[url('/intermediaries/city-outline-desktop.svg')]" />
      </div>
    </section>
  );
};

export default PathToHomeOwnership;
